class TemporaryActions {
    static PRODUCT_DETAIL = 'PRODUCT_DETAIL';
    static GEO_DETAIL = 'GEO_DETAIL';

   static productDetail = (data) => {
       return {
           type:this.PRODUCT_DETAIL,
           data
       }
    }

    static geoDetail = (data) => {
        return {
            type:this.GEO_DETAIL,
            data
        }
     }
}

export default TemporaryActions